import React from 'react';

import _isEmpty from 'lodash/isEmpty';

import { MESSAGE_DISPLAY_FAST_ID } from 'components/core/BusinessInfo/BusinessInfo.constants';
import { multiCaseGet } from 'libs/format';

import { getLayoutComponents } from './LayoutComponentList.utils';
import { InlineFieldContainer } from '../../../common';
import MessageDisplayForm from '../MessageDisplayForm';

import '../../../../styles/core/components/integration-form.scss';

export default function LayoutComponentList({ layouts }) {
  if (_isEmpty(layouts)) {
    return null;
  }

  function getFormForComponent(component) {
    const { index, layoutIndex, id } = component || {};

    const fastId = multiCaseGet(component, 'fastId');

    if (fastId === MESSAGE_DISPLAY_FAST_ID) {
      return (
        <InlineFieldContainer key={id} title="Message Banner" enableDelete={false}>
          <MessageDisplayForm index={index} layoutIndex={layoutIndex} component={component} />
        </InlineFieldContainer>
      );
    }
    return <></>;
  }

  const layoutComponents = getLayoutComponents(layouts, [MESSAGE_DISPLAY_FAST_ID]);

  return <>{layoutComponents.map((component) => getFormForComponent(component))}</>;
}
